import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { LinhaDadoContainer } from "../../styles";

interface LinhaDadoProps {
    rotulo: string;
    children: ReactNode;
}

/** Linha rótulo/valor usada nos cards de dados das configurações. */
export const LinhaDado = ({ rotulo, children }: LinhaDadoProps) => (
    <LinhaDadoContainer>
        <Typography variant="body2" color="text.secondary">{rotulo}</Typography>
        <Box sx={{ textAlign: "right", minWidth: 0 }}>{children}</Box>
    </LinhaDadoContainer>
);
